import { findAllConstructionTypesFromObjects } from 'components/WorkOrderConstructionTypesTabSelect';
import type { BimWorkOrderChangeObjectData } from 'gql/graphql';
import { ProjectMethodologyEnum, WorkOrderStatusEnum } from 'gql/graphql';
import { BimAddOtherModal } from 'pages/Project/BimProject/BimCommonComponents/BimAddOtherModal';
import { CreateOther } from 'pages/Project/Common/Contract/OtherCreate';
import { useConstructionTypesListItems } from 'pages/Project/Common/hooks/useConstructionTypesListItems';

import { useCallback, useMemo, useRef } from 'react';

import { useAddOtherToBimWorkOrderChangeTableData, useAddToBimWorkOrderChange } from './hooks';

type TBimWorkOrderChangeUploadOther = {
    onClose: () => void;
    refreshTable: () => void;
    workOrderChangeId: number;
    constructionTypeId: number | undefined;
    objectsListItems: BimWorkOrderChangeObjectData[];
};

export const BimWorkOrderChangeUploadOther = (props: TBimWorkOrderChangeUploadOther) => {
    const { onClose, constructionTypeId, workOrderChangeId, objectsListItems, refreshTable } = props;
    const { getConstructionTypeName } = useConstructionTypesListItems();

    const tableRef = useRef<HTMLDivElement>(null);

    const workOrderObjects = useMemo(
        () =>
            objectsListItems.filter(
                (item) => item.parentId === null && constructionTypeId === item.constructionType.id,
            ),
        [constructionTypeId, objectsListItems],
    );

    const constructionTypes = useMemo(
        () => findAllConstructionTypesFromObjects({ workOrderChangeObjectsData: objectsListItems }),
        [objectsListItems],
    );

    const {
        tableRows,
        tableColumns,
        getDataStatus,
        onFiltersUpdated,
        tableFilters,
        haveCheckedOthers,
        checkedIds,
        refreshAddTableDataWithSelect,
    } = useAddOtherToBimWorkOrderChangeTableData({
        workOrderChangeId,
        constructionTypeId,
        tableRef,
        workOrderObjects,
    });

    const onAddSuccess = useCallback(() => {
        refreshTable();
        onClose();
    }, [onClose, refreshTable]);

    const { isAddInProgress, addToWorkOrderChangeHandler } = useAddToBimWorkOrderChange({
        checkedIds,
        constructionTypeId,
        workOrderChangeId,
        handlerSuccess: onAddSuccess,
    });

    return (
        <BimAddOtherModal
            modalTitle={`Лимиты прочих затрат для вида строительства "${getConstructionTypeName(constructionTypeId)}"`}
            modalConfirmLabel="Добавить в Изм. к НЗ"
            cancelTextHeader="Отмена действия"
            textConfirmation="Вы уверены, что хотите отменить? Заполненные данные не будут сохранены."
            onConfirm={addToWorkOrderChangeHandler}
            onCancel={onClose}
            haveCheckedOthers={haveCheckedOthers}
            isAddInProgress={isAddInProgress}
            tableColumns={tableColumns}
            tableRows={tableRows}
            tableFilters={tableFilters}
            onFiltersUpdated={onFiltersUpdated}
            fetchStatus={getDataStatus}
            informerMessage="Выбранные прочие затраты по умолчанию будут применены ко всем объектам данного вида строительства. Для того, чтобы исключить объекты, нажмите кнопку раскрытия и снимите выделение"
            tableRef={tableRef}
            leftPanel={
                <CreateOther
                    currentConstructionTypeId={constructionTypeId}
                    reloadHandler={refreshAddTableDataWithSelect}
                    constructionTypes={constructionTypes}
                    methodology={ProjectMethodologyEnum.Bim}
                    workOrderChangeId={workOrderChangeId}
                    workOrderStatus={WorkOrderStatusEnum.InProgress}
                />
            }
        />
    );
};

BimWorkOrderChangeUploadOther.displayName = 'BimWorkOrderChangeUploadOther';
